let container = document.getElementById("sortboxContainer");
if (container) {
  let boxes = Array.from(container.children);
  boxes.sort((a, b) => a.getAttribute("data-title").localeCompare(b.getAttribute("data-title")));
  boxes.forEach(box => container.appendChild(box)); // Append sorted boxes
}

$(document).ready(function () {
  const ciwArrowPrev =
    (window.CIW_CAROUSEL_ARROWS && window.CIW_CAROUSEL_ARROWS.prev) ||
    'https://cdn.shopify.com/s/files/1/0618/4996/0537/files/LeftArrow.svg?v=1733070052';
  const ciwArrowNext =
    (window.CIW_CAROUSEL_ARROWS && window.CIW_CAROUSEL_ARROWS.next) ||
    'https://cdn.shopify.com/s/files/1/0618/4996/0537/files/RightArrow.svg?v=1733070112';
  const ciwNavText = [
    "<img src='" + ciwArrowPrev + "' class='custom-arrow' alt=''>",
    "<img src='" + ciwArrowNext + "' class='custom-arrow' alt=''>",
  ];

  // Top Brands Carousel
  $(".top-brands-carousel").owlCarousel({
    loop: true,
    margin: 20,
    nav: true, // Enable navigation
    navText: ciwNavText,
    dots: true,
    responsive: {
      0: {
        items: 1.5,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 4,
      },
    },
  });

  // Reviews Carousel
  $(".reviews-carousel").owlCarousel({
    loop: true,
    margin: 20,
    nav: true, // Enable navigation
    navText: ciwNavText,
    dots: true,
    responsive: {
      0: {
        items: 1.2,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 3, 
      },
    },
  });

  // Our Brands Carousel
  $(".our-brands-carousel").owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    navText: ciwNavText,
    dots: true,
    responsive: {
      0: {
        items: 1.2, 
        slideBy: 1.2, 
      },
      768: {
        items: 3, 
        slideBy: 3,
      },
      1024: {
        items: 4, 
        slideBy: 4, 
      },
    },
  });
  
  $(".owl-nav").removeClass("disabled");
  // Re-enable navigation dynamically
  $(".owl-carousel").on("changed.owl.carousel", function () {
    $(this).find(".owl-nav").removeClass("disabled");
  });
});

// Handle variant changes for additional media
class VariantAdditionalMediaHandler {
  constructor() {
    this.init();
  }

  init() {
    // Subscribe to variant change events (pub/sub system)
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
    }

    // Also listen to the custom variant:changed event from product-variant-options
    document.addEventListener('variant:changed', this.handleCustomVariantChange.bind(this));
  }

  shouldFilterGalleryByVariant(sectionId) {
    const gallery = document.getElementById(`MediaGallery-${sectionId}`);
    return gallery?.dataset.galleryFilter === 'variant';
  }

  getAllVariants() {
    const root = document.querySelector('product-info.ciw-pdp') || document;
    const variantsScript = root.querySelector('script[type="application/json"][id^="ProductJSON"]');
    if (!variantsScript) return [];

    try {
      const parsed = JSON.parse(variantsScript.textContent) || [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  getVariantLookup() {
    if (!this._variantLookup) {
      this._variantLookup = new Map(
        this.getAllVariants().map((variant) => [String(variant.id), variant])
      );
    }
    return this._variantLookup;
  }

  resolveVariantIdFromCheckedRadios() {
    const selectedByPosition = {};

    document
      .querySelectorAll(
        'variant-selects fieldset input[type="radio"]:checked, .ciw-pdp__variant-fieldset input[type="radio"]:checked'
      )
      .forEach((input) => {
        const positionMatch = String(input.name || '')
          .trim()
          .match(/-(\d+)$/);
        if (positionMatch) {
          selectedByPosition[parseInt(positionMatch[1], 10)] = input.value;
        }
      });

    const positions = Object.keys(selectedByPosition);
    if (!positions.length) return null;

    const match = this.getAllVariants().find((variant) =>
      positions.every(
        (position) =>
          String(variant[`option${position}`] || '').trim() ===
          String(selectedByPosition[position] || '').trim()
      )
    );

    return match?.id ? String(match.id) : null;
  }

  resolveActiveVariantId(fallbackId) {
    const productInfo = document.querySelector('product-info.ciw-pdp');
    if (productInfo && typeof productInfo.resolveSelectedVariant === 'function') {
      const resolved = productInfo.resolveSelectedVariant();
      if (resolved?.id) return String(resolved.id);
    }

    const fromRadios = this.resolveVariantIdFromCheckedRadios();
    if (fromRadios) return fromRadios;

    if (fallbackId) return String(fallbackId);

    const formInput = document.querySelector('form[id^="product-form-"] input[name="id"]');
    return formInput?.value ? String(formInput.value) : null;
  }

  getVariantSizeKey(variant) {
    if (!variant) return '';

    if (variant.option2 != null && this.isSizeLikeOptionValue(variant.option2)) {
      return String(variant.option2).trim();
    }
    if (variant.option1 != null && this.isSizeLikeOptionValue(variant.option1)) {
      return String(variant.option1).trim();
    }

    const parts = String(variant.title || '').split(' / ');
    return parts.length > 1 ? parts[parts.length - 1].trim() : '';
  }

  slideMatchesSelection(slideVariantId, selectedVariant) {
    if (!slideVariantId || !selectedVariant) return false;

    const slideVariant = this.getVariantRecord(slideVariantId);
    if (!slideVariant) return String(slideVariantId) === String(selectedVariant.id);

    const colorMatch =
      String(slideVariant.option1 || '').trim() === String(selectedVariant.option1 || '').trim();
    const sizeMatch =
      String(slideVariant.option2 || '').trim() === String(selectedVariant.option2 || '').trim();
    return colorMatch && sizeMatch;
  }

  eagerLoadGalleryImages(root) {
    if (!root) return;
    root.querySelectorAll('img').forEach((img) => {
      if (img.loading === 'lazy') img.loading = 'eager';
      if (!img.complete || img.naturalWidth === 0) {
        const src = img.currentSrc || img.src;
        if (src) img.src = src;
      }
    });
  }

  shouldRefreshGallery(variant, sectionId, { force = false } = {}) {
    const variantRecord =
      variant?.option1 != null || variant?.title
        ? variant
        : this.getVariantRecord(variant?.id || variant);
    const colorKey = this.getVariantColorKey(variantRecord || variant);
    if (!force && colorKey && colorKey === this.lastGalleryColorKey) return false;
    if (colorKey) this.lastGalleryColorKey = colorKey;
    return true;
  }

  async handleVariantChange(event) {
    const { variant, sectionId } = event.data;
    const variantId = this.resolveActiveVariantId(variant?.id);
    if (!variantId || !sectionId) return;

    const variantRecord = this.getVariantRecord(variantId) || variant;
    if (!this.shouldRefreshGallery(variantRecord, sectionId)) {
      return;
    }

    this.updateAdditionalMediaFromCurrentPage(variantId, sectionId);
  }

  getVariantRecord(variantId) {
    if (!variantId) return null;
    return this.getVariantLookup().get(String(variantId)) || null;
  }

  isSizeLikeOptionValue(value) {
    return /^(xs|s|small|medium|large|xl|xxl|\d+\s*-|\d+mm)/i.test(String(value || '').trim());
  }

  getVariantColorKey(variant) {
    if (!variant) return '';

    if (variant.option1 != null && variant.option2 != null) {
      if (this.isSizeLikeOptionValue(variant.option1)) return String(variant.option2);
      if (this.isSizeLikeOptionValue(variant.option2)) return String(variant.option1);
    }

    const parts = String(variant.title || '').split(' / ');
    return parts.length > 1 ? parts.slice(1).join(' / ') : String(variant.title || '');
  }

  handleCustomVariantChange(event) {
    const { variant } = event.detail;
    
    if (!variant || !variant.id) return;

    // Get section ID from the gallery or modal elements
    let sectionId = null;
    
    // Try to find section ID from gallery
    const galleryElement = document.querySelector('[id^="GalleryViewer-"]');
    if (galleryElement) {
      sectionId = galleryElement.id.replace('GalleryViewer-', '');
    }
    
    // Fallback: try to find from product modal
    if (!sectionId) {
      const modalElement = document.querySelector('[id^="ProductModal-"]');
      if (modalElement) {
        sectionId = modalElement.id.replace('ProductModal-', '');
      }
    }
    
    // Final fallback
    if (!sectionId) {
      sectionId = 'template--17375821201497__main'; // Default section ID
    }

    const run = () => {
      const variantId = this.resolveActiveVariantId(variant.id);
      if (!variantId) return;
      const variantRecord = this.getVariantRecord(variantId) || variant;
      if (!this.shouldRefreshGallery(variantRecord, sectionId)) {
        return;
      }
      this.updateAdditionalMediaFromCurrentPage(variantId, sectionId);
    };

    requestAnimationFrame(run);
  }

  getVariantFrontMediaMap(sectionId) {
    const frontByVariant = new Map();
    const mapEl = document.getElementById(`CiwVariantMediaMap-${sectionId}`);
    if (!mapEl) return frontByVariant;

    try {
      const data = JSON.parse(mapEl.textContent);
      (data.variants || []).forEach((entry) => {
        if (entry.frontMediaId) {
          frontByVariant.set(String(entry.id), String(entry.frontMediaId));
        }
      });
    } catch (e) {
      /* ignore malformed map */
    }

    return frontByVariant;
  }

  resolveActiveMediaIdForVariant(variantId, sectionId) {
    const variantIdStr = String(variantId);
    const featuredByVariant = this.getVariantFeaturedMediaMap(sectionId);
    const featuredMediaId = featuredByVariant.get(variantIdStr);
    if (featuredMediaId) return featuredMediaId;

    const frontByVariant = this.getVariantFrontMediaMap(sectionId);
    return frontByVariant.get(variantIdStr) || null;
  }

  resolveFrontMediaIdForVariant(variantId, sectionId) {
    const variantIdStr = String(variantId);
    const frontByVariant = this.getVariantFrontMediaMap(sectionId);
    const featuredByVariant = this.getVariantFeaturedMediaMap(sectionId);
    const exactFront =
      frontByVariant.get(variantIdStr) || featuredByVariant.get(variantIdStr) || null;

    if (exactFront || this.shouldFilterGalleryByVariant(sectionId)) {
      return this.resolveActiveMediaIdForVariant(variantId, sectionId);
    }

    const colorKey = this.normalizeColorKey(this.getVariantColorKeyFromId(variantIdStr));
    if (colorKey) {
      for (const [id, mediaId] of frontByVariant.entries()) {
        if (this.normalizeColorKey(this.getVariantColorKeyFromId(id)) === colorKey) {
          return mediaId;
        }
      }
    }

    return exactFront;
  }

  getVariantFeaturedMediaMap(sectionId) {
    const mapEl = document.getElementById(`CiwVariantMediaMap-${sectionId}`);
    const featuredByVariant = new Map();
    if (!mapEl) return featuredByVariant;
    try {
      const data = JSON.parse(mapEl.textContent);
      (data.variants || []).forEach((entry) => {
        if (entry.featuredMediaId) {
          featuredByVariant.set(String(entry.id), String(entry.featuredMediaId));
        }
      });
    } catch (e) {
      /* ignore malformed map */
    }
    return featuredByVariant;
  }

  getVariantColorKeyFromId(variantId) {
    if (!variantId) return '';
    return this.getVariantColorKey(this.getVariantRecord(variantId) || { id: variantId });
  }

  normalizeColorKey(value) {
    return String(value || '').trim().toLowerCase();
  }

  filterGalleryByVariant(variantId, sectionId) {
    if (!variantId || !sectionId) return;

    const variantIdStr = String(variantId);
    const selectedVariant = this.getVariantRecord(variantIdStr);
    if (!selectedVariant) return;

    const filterByVariant = this.shouldFilterGalleryByVariant(sectionId);
    const currentColorKey = this.normalizeColorKey(this.getVariantColorKey(selectedVariant));
    const featuredByVariant = this.getVariantFeaturedMediaMap(sectionId);
    const activeMediaId = this.resolveActiveMediaIdForVariant(variantIdStr, sectionId);
    const isMultiVariant = featuredByVariant.size > 1;
    const otherFeaturedMediaIds = new Set();
    featuredByVariant.forEach((mediaId, id) => {
      if (filterByVariant) {
        const entry = this.getVariantRecord(id);
        if (entry && !this.slideMatchesSelection(id, selectedVariant)) {
          otherFeaturedMediaIds.add(mediaId);
        }
      } else if (this.normalizeColorKey(this.getVariantColorKeyFromId(id)) !== currentColorKey) {
        otherFeaturedMediaIds.add(mediaId);
      }
    });

    const gallerySlides = document.querySelectorAll(
      `#GalleryViewer-${sectionId} .ci-gallery-slide, #GalleryViewer-${sectionId} .product__media-item`
    );

    gallerySlides.forEach((slide) => {
      const slideVariantId = slide.getAttribute('data-variant-id');
      const mediaIdFull = slide.getAttribute('data-media-id') || '';
      const mediaIdOnly = mediaIdFull.split('-').pop();

      let show = true;

      if (slideVariantId) {
        if (filterByVariant) {
          show = this.slideMatchesSelection(slideVariantId, selectedVariant);
        } else {
          const slideColorKey = this.normalizeColorKey(this.getVariantColorKeyFromId(slideVariantId));
          if (currentColorKey !== '' && slideColorKey !== '') {
            show = slideColorKey === currentColorKey;
          } else {
            show = slideVariantId === variantIdStr;
          }
        }
      } else if (isMultiVariant && mediaIdOnly && otherFeaturedMediaIds.has(mediaIdOnly)) {
        show = false;
      }

      slide.classList.toggle('ciw-gallery-slide--hidden', !show);

      if (show) {
        slide.removeAttribute('hidden');
        slide.style.removeProperty('display');
        slide.style.visibility = '';
        slide.style.opacity = '';
      } else {
        slide.setAttribute('hidden', '');
        slide.style.display = 'none';
        slide.classList.remove('is-active');
      }
    });

    const viewer = document.getElementById(`GalleryViewer-${sectionId}`);

    const thumbItems = document.querySelectorAll(`#Slider-Thumbnails-${sectionId} .thumbnail-list__item`);
    thumbItems.forEach((item) => {
      const target = item.getAttribute('data-target');
      if (!target) return;
      const slide = viewer?.querySelector(`[data-media-id="${target}"]`);
      const slideHidden = !slide || slide.hasAttribute('hidden') || slide.style.display === 'none';
      if (slideHidden) {
        item.setAttribute('hidden', '');
        item.style.display = 'none';
      } else {
        item.removeAttribute('hidden');
        item.style.removeProperty('display');
      }
    });

    const visibleSlides = Array.from(
      viewer?.querySelectorAll('.ci-gallery-slide') || []
    ).filter(
      (slide) =>
        !slide.hasAttribute('hidden') &&
        !slide.classList.contains('ciw-gallery-slide--hidden') &&
        slide.style.display !== 'none'
    );
    const visibleCount = visibleSlides.length;
    const galleryTotalCounter = document.querySelector(`#GalleryViewer-${sectionId} .slider-counter--total`);
    if (galleryTotalCounter && visibleCount > 0) {
      galleryTotalCounter.textContent = visibleCount;
    }

    visibleSlides.forEach((slide) => slide.classList.remove('is-active'));

    const activeSlide =
      Array.from(visibleSlides).find((slide) => {
        const mediaIdOnly = (slide.getAttribute('data-media-id') || '').split('-').pop();
        return activeMediaId && mediaIdOnly === String(activeMediaId);
      }) ||
      visibleSlides[0];

    if (activeSlide && viewer) {
      activeSlide.classList.add('is-active');
      const mediaGallery = document.querySelector(`#MediaGallery-${sectionId}`);
      if (mediaGallery?.setActiveMedia) {
        mediaGallery.setActiveMedia(activeSlide.dataset.mediaId, false);
      } else if (viewer.scrollTo) {
        viewer.scrollTo({ left: activeSlide.offsetLeft, behavior: 'auto' });
      }
    }

    visibleSlides.forEach((slide) => this.eagerLoadGalleryImages(slide));
    document
      .querySelectorAll(`#Slider-Thumbnails-${sectionId} .thumbnail-list__item:not([hidden])`)
      .forEach((thumb) => this.eagerLoadGalleryImages(thumb));

    this.updateSliderAfterVariantChange(sectionId);
    document.dispatchEvent(
      new CustomEvent('ciw:gallery-filtered', {
        detail: { variantId: variantIdStr, sectionId: sectionId },
      })
    );
  }

  updateAdditionalMediaFromCurrentPage(variantId, sectionId) {
    this.filterGalleryByVariant(variantId, sectionId);

    // Step 1: Hide ALL modal slides first
    const allModalSlides = document.querySelectorAll(`#ProductModal-${sectionId} .ci-modal-slide`);
    allModalSlides.forEach(slide => {
      slide.style.display = 'none';
      // Don't set visibility and opacity here - let the modal handle it
    });

    // Step 2: Get all currently visible gallery slides (these are the ones we need in the modal)
    const visibleGallerySlides = Array.from(
      document.querySelectorAll(`#GalleryViewer-${sectionId} .ci-gallery-slide`)
    ).filter((slide) => !slide.hasAttribute('hidden') && slide.style.display !== 'none');
    const modalContainer = document.querySelector(`#ProductModal-${sectionId} .ci-modal-container > div`);
    
    if (!modalContainer) return;

    // Step 5: For each visible gallery slide, create or show corresponding modal slide
    visibleGallerySlides.forEach((gallerySlide, index) => {
      const mediaId = gallerySlide.getAttribute('data-media-id');
      const mediaIdOnly = mediaId ? mediaId.split('-').pop() : null;
      const variantIdAttr = gallerySlide.getAttribute('data-variant-id');
      
      // Look for existing modal slide by media ID only (never match variant-id alone — same color has multiple images)
      let modalSlide = null;

      if (mediaIdOnly) {
        modalSlide =
          document.querySelector(`#ProductModal-${sectionId} .ci-modal-slide[data-media-id="${mediaIdOnly}"]`) ||
          document.querySelector(`#ProductModal-${sectionId} .ci-modal-slide[data-media-id="${mediaId}"]`);
      }

      if (modalSlide) {
        // Show existing modal slide
        modalSlide.style.display = '';
        // Let the modal navigation handle visibility and opacity
      } else {
        // Create new modal slide
        this.createModalSlideFromGallerySlide(gallerySlide, modalContainer, sectionId);
      }
    });

    // Step 6: Update modal navigation system
    this.updateModalNavigation(sectionId, variantId);
    
    // Step 7: Update slider if it exists
    this.updateSliderAfterVariantChange(sectionId);
  }

  createModalSlideFromGallerySlide(gallerySlide, modalContainer, sectionId) {
    const img = gallerySlide.querySelector('img');
    if (!img) return;

    const imageUrl = img.src;
    const mediaId = gallerySlide.getAttribute('data-media-id');
    const mediaIdOnly = mediaId ? mediaId.split('-').pop() : null;
    const variantId = gallerySlide.getAttribute('data-variant-id');
    const isVariantMedia = gallerySlide.classList.contains('variant-additional-media');

    const modalSlide = document.createElement('div');
    modalSlide.className = `ci-modal-slide${isVariantMedia ? ' variant-additional-media' : ''}`;
    modalSlide.setAttribute('data-media-id', mediaIdOnly || mediaId);
    if (mediaId && mediaId !== mediaIdOnly) {
      modalSlide.setAttribute('data-gallery-media-id', mediaId);
    }
    if (variantId) {
      modalSlide.setAttribute('data-variant-id', variantId);
    }
    // Don't set visibility and opacity - let the modal navigation handle this

    const modalImg = document.createElement('img');
    modalImg.src = imageUrl;
    modalImg.alt = img.alt || 'Product image';
    modalImg.className = 'global-media-settings global-media-settings--no-shadow ciw-pdp-modal__img';
    modalImg.loading = 'lazy';

    modalSlide.appendChild(modalImg);
    modalContainer.appendChild(modalSlide);
  }

  updateAdditionalMedia(additionalMediaUrls, variantId, sectionId) {
    const galleryContainer = document.getElementById(`variant-additional-media-${sectionId}`);
    const modalContainer = document.getElementById(`variant-additional-media-modal-${sectionId}`);

    if (!galleryContainer) return;

    // Clear existing additional media
    galleryContainer.innerHTML = '';
    if (modalContainer) modalContainer.innerHTML = '';

    // Add new additional media for the current variant
    additionalMediaUrls.forEach((imageUrl, index) => {
      const mediaId = `additional-${variantId}-${index + 1}`;
      
      // Add to gallery
      this.addGallerySlide(galleryContainer, imageUrl, mediaId, variantId, sectionId, index + 1);
      
      // Add to modal
      if (modalContainer) {
        this.addModalSlide(modalContainer, imageUrl, mediaId, variantId, sectionId, index + 1);
      }
    });

    // Update modal navigation system
    this.updateModalNavigation(sectionId, variantId);
    
    // Update slider after adding new slides
    this.updateSliderAfterVariantChange(sectionId);
  }

  addGallerySlide(container, imageUrl, mediaId, variantId, sectionId, position) {
    const li = document.createElement('li');
    li.id = `Slide-${sectionId}-${mediaId}`;
    li.className = 'product__media-item slider__slide ci-gallery-slide variant-additional-media';
    li.setAttribute('data-media-id', `${sectionId}-${mediaId}`);
    li.setAttribute('data-variant-id', variantId);

    const isLdGallery = !!document.querySelector('media-gallery.ciw-pdp-gallery--ld');
    const imageMarkup = `
      <img src="${imageUrl}?width=1946" alt="Additional variant image" class="ciw-pdp-gallery__img" loading="lazy"
           sizes="(min-width: 1200px) 715px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)"
           srcset="${imageUrl}?width=246 246w, ${imageUrl}?width=493 493w, ${imageUrl}?width=600 600w, ${imageUrl}?width=713 713w, ${imageUrl}?width=823 823w, ${imageUrl}?width=990 990w, ${imageUrl}?width=1100 1100w, ${imageUrl}?width=1206 1206w, ${imageUrl}?width=1346 1346w, ${imageUrl}?width=1426 1426w, ${imageUrl}?width=1646 1646w, ${imageUrl}?width=1946 1946w"
           width="1946" height="1095">`;

    if (isLdGallery) {
      li.innerHTML = `
        <div class="product-media-container media-type-image media-fit- global-media-settings gradient ciw-pdp-gallery__media-wrap" style="--ratio: 1.0; --preview-ratio: 1.0;">
          <div class="ciw-pdp-gallery__static-image product__modal-opener product__modal-opener--image">
            <div class="product__media media media--transparent ciw-pdp-gallery__media-inner">
              ${imageMarkup}
            </div>
          </div>
        </div>
      `;
    } else {
      li.innerHTML = `
        <div class="product-media-container media-type-image media-fit- global-media-settings gradient ciw-pdp-gallery__media-wrap" style="--ratio: 1.0; --preview-ratio: 1.0;">
          <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#ProductModal-${sectionId}">
            <span class="product__media-icon motion-reduce quick-add-hidden" aria-hidden="true">
              <span class="svg-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 19 19">
                  <path fill="currentColor" fill-rule="evenodd" d="M4.667 7.94a.5.5 0 0 1 .499-.501l5.534-.014a.5.5 0 1 1 .002 1l-5.534.014a.5.5 0 0 1-.5-.5" clip-rule="evenodd"></path>
                  <path fill="currentColor" fill-rule="evenodd" d="M7.926 4.665a.5.5 0 0 1 .501.498l.014 5.534a.5.5 0 1 1-1 .003l-.014-5.534a.5.5 0 0 1 .499-.501" clip-rule="evenodd"></path>
                  <path fill="currentColor" fill-rule="evenodd" d="M12.832 3.03a6.931 6.931 0 1 0-9.802 9.802 6.931 6.931 0 0 0 9.802-9.802M2.323 2.323a7.931 7.931 0 0 1 11.296 11.136l4.628 4.628a.5.5 0 0 1-.707.707l-4.662-4.662A7.932 7.932 0 0 1 2.323 2.323" clip-rule="evenodd"></path>
                </svg>
              </span>
            </span>
            <div class="product__media media media--transparent ciw-pdp-gallery__media-inner">
              ${imageMarkup}
            </div>
            <button class="product__media-toggle quick-add-hidden" type="button" aria-haspopup="dialog" data-media-id="${mediaId}">
              <span class="visually-hidden">Open media ${position} in modal</span>
            </button>
          </modal-opener>
        </div>
      `;
    }

    container.appendChild(li);
  }

  addModalSlide(container, imageUrl, mediaId, variantId, sectionId, position) {
    // Calculate the index based on existing slides
    const existingSlides = document.querySelectorAll(`#ProductModal-${sectionId} .ci-modal-slide`);
    const slideIndex = existingSlides.length + 1;

    const div = document.createElement('div');
    div.className = 'ci-modal-slide variant-additional-media';
    // Use the full media ID with section prefix to match gallery button
    div.setAttribute('data-media-id', `${sectionId}-${mediaId}`);
    div.setAttribute('data-variant-id', variantId);
    // Don't set data-index here - let updateModalNavigation handle all indexing
    div.style.visibility = 'hidden';
    div.style.opacity = '0';

    div.innerHTML = `
      <img class="global-media-settings global-media-settings--no-shadow" 
           src="${imageUrl}?width=1445" 
           alt="Additional variant image" 
           loading="lazy" 
           width="1100" 
           height="1100"
           data-media-id="${mediaId}"
           srcset="${imageUrl}?width=550 550w, ${imageUrl}?width=1100 1100w, ${imageUrl}?width=1445 1445w, ${imageUrl}?width=1680 1680w, ${imageUrl}?width=2048 2048w, ${imageUrl}?width=2200 2200w, ${imageUrl}?width=2890 2890w, ${imageUrl}?width=4096 4096w"
           sizes="(min-width: 750px) calc(100vw - 22rem), 1100px">
    `;

    container.appendChild(div);

  }

  updateModalNavigation(sectionId, currentVariantId = null) {
    const modal = document.querySelector(`#ProductModal-${sectionId}`);
    if (!modal) return;

    if (!currentVariantId) {
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput?.value) {
        currentVariantId = variantInput.value;
      } else {
        const activeGallerySlide = document.querySelector(
          `#GalleryViewer-${sectionId} .ci-gallery-slide.is-active`
        );
        if (activeGallerySlide) {
          currentVariantId = activeGallerySlide.getAttribute('data-variant-id');
        }
      }
    }

    const viewer = document.getElementById(`GalleryViewer-${sectionId}`);
    const currentColorKey = currentVariantId
      ? this.normalizeColorKey(this.getVariantColorKeyFromId(currentVariantId))
      : '';

    const isGallerySlideVisible = (slide) =>
      slide && !slide.hasAttribute('hidden') && slide.style.display !== 'none';

    const findGallerySlideForModal = (modalSlide) => {
      if (!viewer) return null;
      const slideMediaId = modalSlide.getAttribute('data-media-id') || '';
      const mediaIdOnly = slideMediaId.split('-').pop();

      return (
        viewer.querySelector(`.ci-gallery-slide[data-media-id="${slideMediaId}"]`) ||
        (mediaIdOnly &&
          viewer.querySelector(`.ci-gallery-slide[data-media-id$="-${mediaIdOnly}"]`)) ||
        (mediaIdOnly && viewer.querySelector(`.ci-gallery-slide[data-media-id*="${mediaIdOnly}"]`))
      );
    };

    const allModalSlides = document.querySelectorAll(`#ProductModal-${sectionId} .ci-modal-slide`);

    allModalSlides.forEach((slide) => {
      const gallerySlide = findGallerySlideForModal(slide);
      let shouldBeVisible = isGallerySlideVisible(gallerySlide);

      if (!shouldBeVisible && !gallerySlide) {
        const slideVariantId = slide.getAttribute('data-variant-id');
        if (slideVariantId && currentColorKey) {
          const slideColorKey = this.normalizeColorKey(this.getVariantColorKeyFromId(slideVariantId));
          shouldBeVisible = slideColorKey === currentColorKey;
        }
      }

      if (shouldBeVisible) {
        slide.style.removeProperty('display');
        slide.style.removeProperty('visibility');
        slide.style.removeProperty('position');
        slide.style.removeProperty('z-index');
      } else {
        slide.style.setProperty('display', 'none', 'important');
        slide.style.setProperty('visibility', 'hidden', 'important');
      }
    });

    // Let the modal reinitialize itself to handle the new slide configuration
    if (modal.reinitialize) {
      modal.reinitialize();
    } else {
      // Fallback for older modal implementation
      modal.initializeModal();
      if (modal.setupNavigation) {
        modal.setupNavigation();
      }
      if (modal.showImageAtIndex) {
        modal.showImageAtIndex(1);
      }
    }
  }

  createModalSlidesForVariant(variantId, sectionId, gallerySlides) {
    const modalContainer = document.querySelector(`#ProductModal-${sectionId} .ci-modal-container > div`);
    if (!modalContainer) return;

    gallerySlides.forEach((gallerySlide, index) => {
      // Extract image URL from gallery slide
      const img = gallerySlide.querySelector('img');
      if (!img) return;

      const imageUrl = img.src;
      const mediaId = gallerySlide.getAttribute('data-media-id');

      // Create modal slide element
      const modalSlide = document.createElement('div');
      modalSlide.className = 'ci-modal-slide variant-additional-media';
      modalSlide.setAttribute('data-media-id', mediaId);
      modalSlide.setAttribute('data-variant-id', variantId);
      modalSlide.style.visibility = 'hidden';
      modalSlide.style.opacity = '0';

      // Create image element for modal
      const modalImg = document.createElement('img');
      modalImg.src = imageUrl;
      modalImg.alt = img.alt || 'Product image';
      modalImg.className = 'ciw-pdp-modal__img';
      modalImg.loading = 'lazy';

      modalSlide.appendChild(modalImg);
      modalContainer.appendChild(modalSlide);
    });
  }

  updateSliderAfterVariantChange(sectionId) {
    // Update slider component if it exists
    const sliderComponent = document.querySelector(`#GalleryViewer-${sectionId}`);
    if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
      sliderComponent.resetPages();
    }

    // Update gallery slider counter
    const totalSlides = document.querySelectorAll(
      `#Slider-Gallery-${sectionId} .product__media-item:not([hidden])`
    ).length;
    const galleryTotalCounter = document.querySelector(`.slider-counter--total`);
    if (galleryTotalCounter) {
      galleryTotalCounter.textContent = totalSlides;
    }
  }
}

// Initialize the handler when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const handler = new VariantAdditionalMediaHandler();
  window.ciwVariantMediaHandler = handler;
  
  // Also initialize modal navigation on page load for the current variant
  setTimeout(() => {
    // Find the current variant from the page
    const productForm = document.querySelector('product-form, variant-selects, variant-radios');
    let currentVariantId = null;
    
    if (productForm) {
      const variantInput = productForm.querySelector('input[name="id"]');
      if (variantInput) {
        currentVariantId = variantInput.value;
      }
    }
    
    // Fallback: try to get from URL or other sources
    if (!currentVariantId) {
      const urlParams = new URLSearchParams(window.location.search);
      currentVariantId = urlParams.get('variant');
    }
    
    // Find section ID
    let sectionId = null;
    const galleryElement = document.querySelector('[id^="GalleryViewer-"]');
    if (galleryElement) {
      sectionId = galleryElement.id.replace('GalleryViewer-', '');
    }
    
    if (sectionId && currentVariantId) {
      const resolvedId = handler.resolveActiveVariantId(currentVariantId);
      handler.updateAdditionalMediaFromCurrentPage(resolvedId || currentVariantId, sectionId);
    }
  }, 100);
});

(function () {
  function fixMobileCategoryTileTitles() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var selectors =
      '.hp-category-tiles__mobile-grid h3,' +
      '.hp-category-tiles__mobile-grid .hp-category-tiles__title,' +
      '.hp-category-tiles__mobile-grid .hp-category-tiles__mcard-title,' +
      '.hp-category-tiles__mobile-grid .hp-category-tiles__mcard-label';

    document.querySelectorAll(selectors).forEach(function (el) {
      el.style.setProperty('font-size', '14px', 'important');
      el.style.setProperty('line-height', '1.2', 'important');
      el.style.setProperty('font-family', 'Inter, Arial, sans-serif', 'important');
      el.style.setProperty('font-weight', '600', 'important');
      el.style.setProperty('letter-spacing', '-0.02em', 'important');
      el.style.setProperty('white-space', 'nowrap', 'important');
      el.style.setProperty('text-align', 'center', 'important');
      el.style.setProperty('color', '#fff', 'important');
      el.style.setProperty('margin', '0', 'important');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMobileCategoryTileTitles);
  } else {
    fixMobileCategoryTileTitles();
  }

  window.addEventListener('resize', fixMobileCategoryTileTitles);
})();

